export const ADMIN_USER_EMAIL = process.env.REACT_APP_ADMIN_USER_EMAIL ?? "";

export const APROX_BOOKING_DURURATION = [
  // {
  //   label: "1 Day",
  //   value: 8,
  // },
  // {
  //   label: "Few days",
  //   value: 1,
  // },
  // {
  //   label: "1 week",
  //   value: 2,
  // },
  // {
  //   label: "Few weeks",
  //   value: 3,
  // },
  {
    label: "1 month",
    value: 4,
  },
  {
    label: "Few months",
    value: 5,
  },
  {
    label: "About a year",
    value: 6,
  },
  {
    label: "Few years",
    value: 7,
  },
];

export const WEEKLY_BOOKING_DURURATION = [
  {
    label: "1 week",
    value: 1,
  },
  {
    label: "Two Weeks",
    value: 2,
  },
  {
    label: "Three Weeks",
    value: 3,
  },
];

export const TIME_SLOTS_30_MIN = Array.from({ length: 48 }, (_, i) => {
  const hour = Math.floor(i / 2);
  const minute = i % 2 === 0 ? "00" : "30";
  const value = `${String(hour).padStart(2, "0")}:${minute}`;
  const period = hour < 12 ? "AM" : "PM";
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  const label = `${displayHour}:${minute} ${period}`;
  return { value, label };
});

export const STATUS_LABELS = [
  {
    value: 1,
    label: "New User",
  },
  {
    value: 2,
    label: "Repeat Customer",
  },
  {
    value: 3,
    label: "Both",
  },
];


export const PAYMENT_METHOD_TYPES = {
  1: "Card",
  2: "CashApp",
  3: "Google Pay",
  4: "Apple Pay",
};

export const SELF_STORAGE = 1;
export const VEHICLE_STORAGE = 2;

export const RESERVATION_STATUS = {
  PENDING_APPROVAL: 0,
  APPROVED: 1,
  DENIED: 2,
  CANCELLED: 3,
  UNDER_TERMINATION_NOTICE: 4,
  DRAFT: 5,
  COMPLETED: 6,
  UNDER_AUCTION: 7,
  AUCTION_COMPLETED: 8,
  AUCTION_CANCELLED: 9,
  TERMINATED: 10,
};

export const RESERVATION_TYPE = {
  WEEKLY: 0,
  MONTHLY: 1,
  DAILY: 2,
  ONE_MONTH: 3,
};

// Numeric roleId as stored on the user record.
export const USER_ROLE_ID = {
  ADMIN: 1,
  CSR: 2,
  USER: 3,
};

// String role labels used in the UI.
export const ROLE = {
  ADMIN: "admin",
  CSR: "csr",
};

export const SPOT_STATUS = {
  VACANT: "vacant",
  OCCUPIED: "occupied",
  UNAVAILABLE: "unavailable",
};

export const SPOT_STATUS_LABEL = {
  vacant: "Vacant",
  occupied: "Occupied",
  unavailable: "Unavailable",
};

export const SPOT_STATUS_OPTIONS = [
  { value: "vacant", label: "Vacant" },
  { value: "occupied", label: "Occupied" },
  { value: "unavailable", label: "Unavailable" },
];

export const MANDATORY_COLOR_ITEM = 'Boat or Jet Ski';

export const TRUCK_TYPE_NAMES = [
    'Truck',
    'Box-Truck',
    'Tractor Trailer',
    'Semi-Trailer',
    '53 Feet Trailer',
    '18 wheeler',
    'Big Rig',
    'Bobtail',
    'Semi-Truck',
    'Truck Trailer'
];

export const ACTION_TYPE_LABELS = {
    0: 'Deduction',
    1: 'Credit',
    2: 'Expiry',
    3: 'Void'
};

export const REWARD_POINTS_TYPE_LABELS = {
    1: 'Booking',
    2: 'Renewal',
    3: 'Extension',
    4: 'Manual',
    5: 'Expiry',
    6: 'Redemption'
};

export const TYPE_BADGE_COLORS = {
    Booking: { bg: '#E8EEFB', fg: '#19399E' },
    Renewal: { bg: '#E6F4EA', fg: '#1E7E34' },
    Extension: { bg: '#FFF4E5', fg: '#B36B00' },
    Manual: { bg: '#F0E8FB', fg: '#5B2EAB' },
    "Stackkly Bonus": { bg: '#E6F4EA', fg: '#1E7E34' },
    Expiry: { bg: '#FDECEC', fg: '#B71C1C' },
    Redemption: { bg: '#FFF4E5', fg: '#B36B00' },
    Deduction: { bg: '#FDECEC', fg: '#B71C1C' },
    Credit: { bg: '#E6F4EA', fg: '#1E7E34' },
    Void: { bg: '#ECEFF1', fg: '#546E7A' }
};
